import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { appActions } from './app-actions';
import { distinctUntilChanged, filter, tap } from 'rxjs';
import { BizzMineLocalStorageService } from 'src/app/shared/services/localStorage/bizzmine-local-storage.service';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { SyncService } from 'src/app/core/services/sync/sync.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { SyncQueueService } from 'src/app/core/services/sync/sync-queue.service';

@Injectable()
export class AppEffects {
  private actions$ = inject(Actions);
  private localStorage = inject(BizzMineLocalStorageService);
  private networkService = inject(NetworkService);
  private syncService = inject(SyncService);
  private pwaService = inject(PwaService);
  private syncQueueService = inject(SyncQueueService)

   public appModeOffline$ = createEffect(() => this.actions$.pipe(
    ofType(appActions.offlineModeChanged),
    filter((action) => action.isOnline === false), // Only react to going offline
    tap(() => {
    this.localStorage.setItem('appOffline', 'true');
    })
  ), {dispatch: false});

  public appModeOnline$ = createEffect(() => this.actions$.pipe(
    ofType(appActions.offlineModeChanged),
    distinctUntilChanged((prev, curr) => prev.isOnline === curr.isOnline),
    filter((action) => action.isOnline === true && this.networkService.isOnline && this.pwaService.isPwa()), // Only react to going online
    tap(() => {
      if(this.localStorage.getItem('appOffline') == 'true') {
        this.syncQueueService.pause();
      }
      this.localStorage.setItem('appOffline', 'false');
      this.pwaService.getMaxDaysOfflinePwaUsage();
      this.syncService.sync();
    })
  ), {dispatch: false});
}